exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-dropzone{width:100%;height:150px;border:2px dashed #666;border-radius:5px;box-sizing:border-box;padding:15px;font-style:italic;display:flex;flex-flow:wrap;align-items:center}.upload-preview-card .card-img-top{height:180px;object-fit:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/upload.scss
// module id = 87
// module chunks = 0